import Scene from "./Scene";
import common from "../common";
import {translate} from "../utils";
import Drawing from "../drawing/Drawing";
import DrawingTextureHack from "../drawing/DrawingTextureHack";
import DrawingSpine from "../drawing/DrawingSpine";
import World from "../game/World";
import ConfirmDialog from "../ui/ConfirmDialog";
import BlueprintCarousel from "../ui/BlueprintCarousel";
import ProgressBar from "../ui/ProgressBar";
import ColorPanel from "../ui/ColorPanel";
import ConfirmRestartDialog from "../ui/ConfirmRestartDialog";
import {Emitter} from "pixi-particles";

export default class DrawingScene extends Scene {

    constructor() {
        super();

        /**
         * @type {(*|Array<any>)[]}
         * @private
         */
        // this._vehicleData = [P3.assets.json("kart_1_data")];

        /**
         * @type {(*|Array<any>)[]}
         * @private
         */
        //this._currentVehicleData = P3.utils.selectRandom(this._vehicleData);

        this._slotIndex = -1;

        this._paths = [];

        this._drawLock = true;

        this._groupcount = 0;

    }

    init() {
        super.init();

        this._drawingLayer = new PIXI.Container();
        this.addChild(this._drawingLayer);

        this._bg = new PIXI.Sprite(P3.assets.texture("bg_choose_a_rocket_screen"));
        this._bg.anchor.set(0.5);
        this._bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);// todo - magic numbers
        this._drawingLayer.addChild(this._bg);

        this._drawing = new Drawing();
        this._drawing.signals.beginPath.add(this.onBeginPath, this);
        this._drawing.signals.endPath.add(this.onEndPath, this);
        this._drawing.init();
        this._drawing.enabled = false;
        this._drawingLayer.addChild(this._drawing);

        this._camera = new P3.NewCamera(
            new PIXI.Point(0, 0),
            new PIXI.Point(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5)
        );
        this._camera.zoom = 0.5;
        this._camera.addLayer(new P3.CameraLayer(this._drawingLayer, new PIXI.Point(1, 1)));

        this._interaction = new PIXI.Container();
        this._interaction.interactive = true;
        this._interaction.hitArea = new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this.addChild(this._interaction);

        this.addInteractionListeners();

        this._camera.setTarget(new PIXI.Point(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5));

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_secondary_medium_orange_out');
        states.over = P3.assets.texture('btn_secondary_medium_orange_over');
        states.down = P3.assets.texture('btn_secondary_medium_orange_down');
        states.icon = P3.assets.texture('icon_redo');

        this._redoButton = new P3.Button(states);
        this._redoButton.signals.click.add(this.onRedoClick, this);
        this._redoButton.enabled = false;
        this._redoButton.visible = false;
        this._redoButton.alpha = 0.7;
        this._redoButton.position.set(common.STAGE_WIDTH * 0.5 + 220, common.STAGE_HEIGHT - 85);
        this.addChild(this._redoButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_large_green_out');
        states.over = P3.assets.texture('btn_primary_large_green_over');
        states.down = P3.assets.texture('btn_primary_large_green_down');
        states.icon = P3.assets.texture('icon_done');

        this._approveButton = new P3.Button(states);
        this._approveButton.clickSoundName = "sfx_click";
        this._approveButton.overSoundName = "sfx_rollover";
        this._approveButton.signals.click.add(this.onApproveButtonClick, this);
        this._approveButton.position.set(common.STAGE_WIDTH * 0.5 + 395, common.STAGE_HEIGHT - 110);

        this._approveButton.enabled = false;
        this._approveButton.visible = false;
        this._approveButton.alpha = 0.7;

        this.addChild(this._approveButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_tertiary_small_out");
        states.over = P3.assets.texture("btn_tertiary_small_over");
        states.down = P3.assets.texture("btn_tertiary_small_down");
        states.icon = P3.assets.texture("icon_sound");
        states.iconAlt = P3.assets.texture("icon_sound_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.clickSoundName = "sfx_click";
        this._muteButton.overSoundName = "sfx_rollover";
        this._muteButton.signals.up.add(function () {
            common.saveData.data.mute = !P3.audio.isMuted();
            common.saveData.save();
        }, this);
        this.addChild(this._muteButton);

        this._blueprintCarousel = new BlueprintCarousel(12);
        this._blueprintCarousel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 50);
        this._blueprintCarousel.signals.selected.once(this.onBlueprintSelected, this);
        this.addChild(this._blueprintCarousel);

        this._tom = new PIXI.spine.Spine(P3.assets.spineData("tom_side"));
        this._tom.autoUpdate = false;
        //this._tom.state.setAnimation(0, "idle2", true);
        this._tom.stateData.defaultMix = 0.1;
        this._tom.scale.set(0.8);
        this._tom.position.set(common.STAGE_WIDTH * 0.5 - 900, common.STAGE_HEIGHT * 1.5 - 50);
        this._drawingLayer.addChild(this._tom);

        this.dialog = new ConfirmRestartDialog(translate('undo_confirm'));
        this.dialog.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.dialog.visible = false;
        this.addChild(this.dialog);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_tertiary_small_out");
        states.over = P3.assets.texture("btn_tertiary_small_over");
        states.down = P3.assets.texture("btn_tertiary_small_down");
        states.icon = P3.assets.texture("icon_back");

        this._backButton = new P3.Button(states);
        this._backButton.clickSoundName = "sfx_click";
        this._backButton.overSoundName = "sfx_rollover";
        this._backButton.signals.click.once(this.onBackClick, this);

        this._confirmDrawingDialog = new ConfirmDialog(translate("ready"));
        this._confirmDrawingDialog.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 220);
        this._confirmDrawingDialog.visible = false;
        this.addChild(this._confirmDrawingDialog);

        this._confirmDrawingDialog.signals.confirm.once(this.onConfirmDrawing, this);
        this._confirmDrawingDialog.signals.deny.add(this.onRedoDrawing, this);

        this._confirmRestartDialog = new ConfirmRestartDialog(translate("restart_confirm"));
        this._confirmRestartDialog.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 220);
        this._confirmRestartDialog.visible = false;
        this._confirmRestartDialog.bg.visible = false;
        this.addChild(this._confirmRestartDialog);

        this._confirmRestartDialog.signals.confirm.once(this.onConfirmRestart, this);
        this._confirmRestartDialog.signals.deny.add(this.onCancelRestart, this);

        this._colorPanel = new ColorPanel(common.config.colors);
        this._colorPanel.position.set(common.STAGE_WIDTH * 0.5 + 390, 0);
        this._colorPanel.visible = false;
        this._colorPanel.signals.colorSelected.add(this.onColor, this);
        this.addChild(this._colorPanel);

        this._drawingTom = new PIXI.spine.Spine(P3.assets.spineData("tom_side"));
        this._drawingTom.autoUpdate = false;
        this._drawingTom.state.setAnimation(0, "idle2", true);
        this._drawingTom.stateData.defaultMix = 0.1;
        this._drawingTom.scale.set(0.6);
        this._drawingTom.position.set(common.STAGE_WIDTH * 0.5 - 400, common.STAGE_HEIGHT + 140);
        this._drawingTom.visible = false;
        this.addChild(this._drawingTom);

        this._drawingTomStart = this._drawingTom.position.clone();

        this._jerry = new PIXI.spine.Spine(P3.assets.spineData("jerry"));
        this._jerry.skeleton.setSlotsToSetupPose();
        this._jerry.autoUpdate = false;
        this._jerry.position.set(common.STAGE_WIDTH * 0.5 + 330, common.STAGE_HEIGHT + 80);
        this._jerry.visible = false;
        this.addChild(this._jerry);

        this.animateTom();

        this._ambientLoop = P3.audio.playSound('sfx_ambient_birds_00', {loop: true});

        this._constructEmitter = new Emitter(
            this,
            [P3.assets.texture("particle_smoke"), P3.assets.texture("particle_smoke1")],
            P3.assets.json("emitter_construction_00")
        );
        this._constructEmitter.emit = false;
        this._constructEmitter.autoUpdate = false;
        this._constructEmitter.updateOwnerPos(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
    }

    animateTom() {
        this._tom.state.setAnimation(0, P3.utils.selectRandom([
            "idle_action_hands_behind_back",
            "idle_action_holding_chin",
            "idle_action_paws_up",
            "idle_action_scratching_head",
            "idle_action_thinking"
        ]), false);
        this._tom.state.addAnimation(0, P3.utils.selectRandom(["idle_hold_blinking", "idle_hold_looking_straight"]), true, 0);
        this._tomAnimationDelay = P3.utils.delayg(this._tweens, Math.random() * 6 + 6, () => this.animateTom());
    }

    destroy() {
        this._ambientLoop && this._ambientLoop.stop();
        super.destroy();
        this.removeInteractionListener();
    }

    resize() {
        super.resize();

        this._drawing.resize();

        // this._muteButton.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 90, 90);
        // this._backButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, 90);
        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 90, 90);

    }

    animateIn() {
        /*
        this._playButton.alpha = 0.3;
        new P3.utils.TWEEN.Tween(this._playButton, this._tweens)
            .delay(190)
            .onStart(() => this._playButton.visible = true)
            .to({alpha: 1}, 210)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .start();
         */
    }

    update(dt = window.deltaTime) {
        super.update();

        this._constructEmitter.update(dt);
        this._tom.update(dt);
        this._drawingTom.update(dt);
        this._jerry.update(dt);

        this._camera.update();
        this._drawing.update();
        this._colorPanel.update();

        if (this._spine) {
            this._spine.update(dt);
            this._pencilSpine.update(dt);
        }

        this._progressBar && this._progressBar.update();

        this._confirmDrawingDialog.update();
        this._confirmRestartDialog.update();
        this.dialog.update();
        /// if (P3.input.isKeyPressed(P3.keys.SPACE)) {
        //this.randomize();
        ///  }
    }

    end() {
        // pass control to world
        /*
        this._world.setRocket(this._spine);
        this._spine = null;
        this._world.begin();
         */

        this._confirmDrawingDialog.visible = true;
        this._colorPanel.visible = false;

        this._progressBar.visible = false;
        this._redoButton.visible = false;
        this._approveButton.visible = false;

        this._jerry.state.setAnimation(0, "cheeky_no_controller", false);
        this._jerry.visible = true;


    }

    addInteractionListeners() {
        this._interaction.on('mousedown', this._drawing.onPointerDown, this._drawing);
        this._interaction.on('mousemove', this._drawing.onPointerMove, this._drawing);
        this._interaction.on('mouseup', this._drawing.onPointerUp, this._drawing);
        this._interaction.on('mouseupoutside', this._drawing.onPointerUp, this._drawing);
        this._interaction.on('touchstart', this._drawing.onPointerDown, this._drawing);
        this._interaction.on('touchmove', this._drawing.onPointerMove, this._drawing);
        this._interaction.on('touchend', this._drawing.onPointerUp, this._drawing);
        this._interaction.on('touchendoutside', this._drawing.onPointerUp, this._drawing);
        //this._interaction.on('pointerupoutside', this._drawing.onPointerUp, this._drawing);
    }

    removeInteractionListener() {
        this._interaction.off('mousedown', this._drawing.onPointerDown, this._drawing);
        this._interaction.off('mousemove', this._drawing.onPointerMove, this._drawing);
        this._interaction.off('mouseup', this._drawing.onPointerUp, this._drawing);
        this._interaction.off('mouseupoutside', this._drawing.onPointerUp, this._drawing);
        this._interaction.off('touchstart', this._drawing.onPointerDown, this._drawing);
        this._interaction.off('touchmove', this._drawing.onPointerMove, this._drawing);
        this._interaction.off('touchend', this._drawing.onPointerUp, this._drawing);
        this._interaction.off('touchendoutside', this._drawing.onPointerUp, this._drawing);
        //this._interaction.off('pointerupoutside', this._drawing.onPointerUp, this._drawing);
    }

    nextSlot(repeat = false) {

        // this._colorPanel.visible = false;
        this._colorPanel.animateOut();

        const t = repeat ? this._slots[this._slotIndex] : this._slots[++this._slotIndex];

        t.name = "" + (this._slotIndex + 1);
        t.order = this._slotIndex + 1;

        let slot = this._spine.skeleton.findSlot(t.name);

        // set drawing style
        this._drawing.style = t.style;
        this._drawing.beginSlot(t.boolean, t.name);
        this._drawing.enabled = true;
        this._drawing.grouped = t.grouped;

        // if (Math.random() > 0.3 && this._slotIndex !== 0)
        //  this.randomText();

        if (repeat) {
            //this.setProgress(true);
            // this._progressBar.updateFill(-1);

            let inTween = new P3.utils.TWEEN.Tween(slot.currentSprite, this.tweens)
                .to({
                    alpha: 1
                }, 300)
                .delay(1000)
                .onUpdate((v) => {
                    this._pencilSpine.alpha = v.alpha;
                })
                .easing(P3.utils.TWEEN.Easing.Linear.None);

            new P3.utils.TWEEN.Tween(slot.currentSprite, this.tweens)
                .to({
                    alpha: 0
                }, 800)
                .easing(P3.utils.TWEEN.Easing.Linear.None)
                .onUpdate((v) => {
                    this._pencilSpine.alpha = v.alpha;
                })
                .onComplete(() => {
                    slot.currentSprite.anchor.set(0.5);
                    this._spine.hackTextureBySlotName(t.name, this._originalTexture, this._originalTexture.orig);
                    inTween.start();
                })
                .start();
        }

        //todo - can probably remove below
        /*
        const guideSlotName = t.name;
        const guide = this._spine.skeleton.findSlot(guideSlotName);
        // console.log(guide);
        if (guide) {
            const guideSprite = guide.currentSprite;
            guideSprite && (guideSprite.visible = true);
        }

         */

        this._fadetween && this._fadetween.stop();

        // hide the slot whilst we are drawing
        const sprite = slot.currentSprite ? slot.currentSprite : slot.currentMesh ? slot.currentMesh : null;
        sprite && (sprite.visible = true);
        sprite && (sprite.alpha = this._isDrawing ? 0.5 : 1);

        // console.log(sprite);

        // display the guide
        this._pencilSpine.state.setAnimation(0, t.name, false);
        this._pencilSpine.alpha = 1;

        let localPos = this._drawingLayer.toLocal(new PIXI.Point(sprite.x, sprite.y), slot.currentSprite.parent);

        // animate camera
        new P3.utils.TWEEN.Tween(this._camera.target, this.tweens)
            .to({
                x: localPos.x,
                y: localPos.y
            }, 700)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onStart(() => this.onZoomBegin())
            .onComplete(() => this.onZoomComplete())
            .start();

        new P3.utils.TWEEN.Tween(this._camera, this.tweens)
            .to({
                zoom: t.camera.zoom
            }, 700)
            .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
            .start();

        this._tom.state.setAnimation(0, "idle", true);
        this._spine.update(0);

    }

    createSpine(id) {
        this._spine = new DrawingSpine(P3.assets.spineData("rocket_" + P3.utils.padNum(id, 2)));
        this._spine.autoUpdate = false;
        this._spine.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 100);
        this._drawingLayer.addChild(this._spine);

        this._pencilSpine = new PIXI.spine.Spine(P3.assets.spineData("rocket_" + P3.utils.padNum(id, 2) + "_paths"));
        this._pencilSpine.autoUpdate = false;
        this._pencilSpine.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 + 100);
        this._drawingLayer.addChild(this._pencilSpine);

        this._pencil = this._pencilSpine.skeleton.findSlot("guide_pencil");

        // hide sprites
        const slots = this._spine.skeleton.slots;
        for (let i = 0; i < slots.length; i++) {
            slots[i].currentSprite && (slots[i].currentSprite.visible = false);
        }

        this._spine.skeleton.setSlotsToSetupPose();
    }

    generateHack() {

        //  if (this._slots[this._slotIndex].grouped && ++this._groupcount < this._slots[this._slotIndex].groupcount)
        //    return;

        this._groupcount = 0;
        this._drawing.grouped = false;
        this._drawing.enabled = false;

        const path = this._path;
        const source = this._source;

        if (path) {
            this._isDrawing = false;
            const t = this._slots[this._slotIndex];
            const slot = this._spine.skeleton.findSlot("" + t.name);

            const center = this._drawingLayer.toLocal(slot.currentSprite.position, slot.currentSprite.parent);

            path.name = "path_" + t.name;

            this._originalTexture = slot.currentSprite.texture.clone();

            //slot.currentSprite.texture.destroy(true);

            const hack = DrawingTextureHack.create(path, slot, center);

            this._spine.addTextureHack(hack);

            // ensure slot is visible
            //  console.log(slot);
            const sprite = slot.currentSprite ? slot.currentSprite : slot.currentMesh ? slot.currentMesh : null;
            sprite && (sprite.visible = true);

            source.enabled = false;

            // this._approveButton.alpha = this._redoButton.alpha = 1;
            ///   this._approveButton.enabled = this._redoButton.enabled = true;
            //   this._approveButton.filters = this._redoButton.filters = null;


        }

    }

    toggleApproveButton(activate) {

        if (activate) {
            this._approveButton.alpha = this._redoButton.alpha = 1;
            this._approveButton.enabled = this._redoButton.enabled = true;
            // this._approveButton.filters = this._redoButton.filters = null;
        } else {
            this._approveButton.enabled = this._redoButton.enabled = false;
            this._approveButton.alpha = this._redoButton.alpha = 0.7;
        }

    }

    randomCelebration() {
        // set to random animation then go back to idle
        this._tom.state.setAnimation(0, P3.utils.selectRandom(["good_job", "well_done", "yes", "excited"]), false);
        this._tom.state.addAnimation(0, "idle2", true, 0);
    }

    onBeginPath() {

        if (this._drawLock)
            return;

        this._isDrawing = true;

        this._drawingsound && this._drawingsound.stop();
        this._drawingsound = P3.audio.playSound('sfx_drawing_loop_00', {loop: true});

        new P3.utils.TWEEN.Tween(this._pencilSpine, this.tweens)
            .to({
                alpha: 0
            }, 150)
            .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
            .start();

    }

    onEndPath(source, path) {

        this._drawingsound && this._drawingsound.stop();
        if (!this._drawLock) P3.audio.playSound('sfx_drawing_fill_00');

        if (this._drawLock || (this._slots[this._slotIndex].grouped && ++this._groupcount < this._slots[this._slotIndex].groupcount))
            return;

        this._source = source;
        this._path = path;

        //P3.audio.playSound('sfx_btn_ui_commit_00');

        new P3.utils.TWEEN.Tween(this._drawingTom, this._tweens)
            .to({
                alpha: 0,
                x: this._drawingTomStart.x - 400
            }, 450)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(() => {

                // animate camera zoom out
                new P3.utils.TWEEN.Tween(this._camera.target, this.tweens)
                    .to({
                        x: common.STAGE_WIDTH * 0.5,
                        y: common.STAGE_HEIGHT * 0.5
                    }, 700)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .onComplete(() => {

                        this.toggleApproveButton(true);
                        this._colorPanel.animateIn();

                        this.randomCelebration();

                    })
                    .start();

                new P3.utils.TWEEN.Tween(this._camera, this.tweens)
                    .to({
                        zoom: 0.5
                    }, 700)
                    .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
                    .onStart(() => this.onUnzoomBegin())
                    .onComplete(() => this.onUnzoomComplete())
                    .start();

            })
            .start();


        this.generateHack();


        /*
        if (!this._slots[this._slotIndex].grouped) {

        } else {
            for (let i = 0; i < this._groupcount; i++) {
                this.generateHack();
            }
        }

         */


        //  this._approveButton.enabled = this._redoButton.enabled = false;
        // this._approveButton.alpha = this._redoButton.alpha = 0.7;

        /*

        if (this._drawLock)
            return;

        this._drawingsound && this._drawingsound.stop();
        P3.audio.playSound('sfx_drawing_fill_00');

        // If we have a slot with multiple lines, e.g. whiskers or eye lashes, we let the user draw all of those first.
        console.log(this._slots[this._slotIndex].groupcount);
        console.log(this._groupcount);

        if (this._slots[this._slotIndex].grouped && ++this._groupcount < this._slots[this._slotIndex].groupcount)
            return;

        this._groupcount = 0;
        this._drawing.grouped = false;
        this._drawing.enabled = false;

        //this.setProgress();

        if (path) {
            this._isDrawing = false;
            const t = this._slots[this._slotIndex];
            const slot = this._spine.skeleton.findSlot("" + t.name);

            const center = this._drawingLayer.toLocal(slot.currentSprite.position, slot.currentSprite.parent);

            path.name = "path_" + t.name;

            this._originalTexture = slot.currentSprite.texture.clone();

            const hack = DrawingTextureHack.create(path, slot, center);

            this._spine.addTextureHack(hack);

            // ensure slot is visible
            console.log(slot);
            const sprite = slot.currentSprite ? slot.currentSprite : slot.currentMesh ? slot.currentMesh : null;
            sprite && (sprite.visible = true);

            source.enabled = false;

            this._approveButton.alpha = this._redoButton.alpha = 1;
            this._approveButton.enabled = this._redoButton.enabled = true;
            this._approveButton.filters = this._redoButton.filters = null;

        }

         */
    }

    onColor(button) {

        if (this._path) {

            if (button.color) {

                const strokeColor = new P3.math.Color().setHex(button.color);

                if (this._drawing.style.fill.enabled) {
                    this._path.fillColor = button.color;
                    strokeColor.v = 0.5;
                }

                // hacks because for some reason stroke is lighter not darker on this color
                if (button.color !== "#3a3a3b")
                    this._path.strokeColor = strokeColor.toHex();
                else {
                    this._path.strokeColor = "#1e1e20";
                }

            } else {
                // if no color its the clear color button
                if (this._drawing.style.fill.enabled)
                    this._path.fillColor = this._drawing.style.fill.color;

                this._path.strokeColor = this._drawing.style.stroke.color;

                if (this._path.fillColor && this._path.fillColor.gradient) {
                    this._path.fillColor.gradient.origin = this._path.bounds.leftCenter;
                    this._path.fillColor.gradient.destination = this._path.bounds.rightCenter;

                    this._path.fillColor.origin = this._path.bounds.leftCenter;
                    this._path.fillColor.destination = this._path.bounds.rightCenter;
                }
            }

            this.generateHack();

        }

        this.randomCelebration();

        P3.audio.playSound("sfx_change_colour_fill_00");

    }

    onApproveButtonClick() {

        //this.generateHack();

        if (this._slotIndex === this._slots.length - 1) {
            this.end();
        } else {
            this._groupcount = 0;
            this.nextSlot(false);
            this._progressBar.updateFill(1);
        }

        this.toggleApproveButton(false);
    }

    onBlueprintSelected() {
        const id = this._blueprintCarousel.index + 1;
        this.createSpine(id);
        this._slots = P3.assets.json("rocket_" + P3.utils.padNum(id, 2) + "_data");
        this._drawLock = false;
        this.nextSlot(false);
        this._blueprintCarousel.visible = false;
        this._drawing.enabled = true;
        this._approveButton.visible = true;
        this._redoButton.visible = true;

        common.rocketId = id;

        this._progressBar = new ProgressBar(this._slots.length);
        this._progressBar.position.set(common.STAGE_WIDTH * 0.5 - 110, common.STAGE_HEIGHT - 100);
        this.addChild(this._progressBar);

        this._progressBar.updateFill(1);

        if (this._tomAnimationDelay)
            this._tomAnimationDelay.stop();
    }

    onRedoClick() {
        if (this.dialog.visible) return;
        this.dialog.visible = true;

        this.dialog.signals.confirm.once(() => {
            P3.audio.playSound('sfx_erase_item_00');
            this._groupcount = 0;
            this.nextSlot(true);

            this._approveButton.enabled = this._redoButton.enabled = false;
            this._approveButton.alpha = this._redoButton.alpha = 0.7;
            // this._approveButton.filters = [this._CMF];
            this.dialog.visible = false;
            // this._progressBar.updateFill(-1);

        }, this);
        this.dialog.signals.deny.once(() => {
            this.dialog.visible = false;
        });
    }

    onBackClick() {
        this.signals.home.dispatch();
    }

    onZoomBegin() {
        //console.log("zoom begin");
        new P3.utils.TWEEN.Tween(this._tom, this._tweens)
            .to({
                alpha: 0,
                x: this._tom.x - 300
            }, 650)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    onZoomComplete() {
        this._drawLock = false;
        //this._tom.visible = false;

        //  const target = this._drawingTom.position.clone();
        this._drawingTom.visible = true;
        this._tom.visible = false;
        this._drawingTom.x = this._drawingTomStart.x - 400;

        new P3.utils.TWEEN.Tween(this._drawingTom, this._tweens)
            .to({
                alpha: 1,
                x: this._drawingTomStart.x
            }, 450)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();

    }

    onUnzoomBegin() {
        this._tom.visible = true;
        new P3.utils.TWEEN.Tween(this._tom, this._tweens)
            .to({
                alpha: 1,
                x: this._tom.x + 300
            }, 650)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    onUnzoomComplete() {
        this._drawingTom.visible = false;
    }

    onConfirmRestart() {
        this.signals.previous.dispatch();
    }

    onCancelRestart() {
        this._confirmDrawingDialog.visible = true;
        this._confirmRestartDialog.visible = false;
    }

    onConfirmDrawing() {

        /*
        const listener = {
            complete: (entry) => {
                common.saveData.saveSpineHacks("rocket", this._spine);
                this.signals.next.dispatch();
                this._jerry.state.removeListener(listener);
            }
        };
        this._jerry.state.addListener(listener);

        this._jerry.state.setAnimation(0, "cheeky_no_controller", false);
        this._jerry.visible = true;
        */

        this._confirmDrawingDialog.visible = false;

        common.saveData.saveSpineHacks("rocket", this._spine);

        P3.audio.playSound("sfx_construct_rocket");
        this._constructEmitter.emit = true;

        P3.utils.delayg(this._tweens, 1.5, () => this.signals.next.dispatch());

    }

    onRedoDrawing() {
        this._confirmDrawingDialog.visible = false;
        this._confirmRestartDialog.visible = true;
    }
}